<template>
  <div class="white-container full-page-container common-table">
    <el-form ref="form" :model="form" label-width="110px" size="small" label-position="left" style="margin-top:20px">
      <el-form-item label="活动标题" prop="name" style="width: 460px">
        {{ form.name }}
      </el-form-item>
      <el-form-item label="活动类型" prop="uaraEventTypeId" style="width: 460px">
        {{ statusList.find(item => item.id == form.uaraEventTypeId)?.name }}
      </el-form-item>
      <el-form-item label="活动城市" prop="city" style="width: 460px">
        {{ form.city }}
      </el-form-item>
      <el-form-item label="活动时间" prop="beginTime" style="width: 460px">
        {{ form.beginTime }}
      </el-form-item>
      <el-form-item label="上传图片/视频" prop="photos">
        <div class="coupon-upload flex">
          <el-upload ref="uploader" class="uploader" action="" :on-change="handlePushUploader" :auto-upload="false" accept="image/*" multiple>
            <el-button slot="trigger" size="small">选择文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">上传到服务器</el-button>
          </el-upload>
          <div class="coupon_tip upload_tips" style="color:#BBBBBB;margin-left:10px">支持上传*.png、*.jpg，大小不超过5M</div>
        </div>
      </el-form-item>
      <div v-if="Array.isArray(form.photos)&&form.photos.length" class="image-list flex">
        <div v-for="(item,index) in form.photos" :key="index" class="image-item">
          <div class="img-wrap">
            <img :src="item.url" alt="">
            <div v-if="!item.isCoverPhoto" class="cover">封面</div>
            <div class="mask">
              <i class="el-icon-close close-icon" @click="remove(index)" />
              <div class="operation">
                <el-button type="text" style="display:block;color:#fff;text-decoration:underline;width:100%;" @click="onPreview(index)">查看图片</el-button>
                <el-button type="text" style="display:block;color:#fff;text-decoration:underline;margin-left:0;;width:100%;" @click="setCover(index)">设为封面</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div class="flex btns">
      <el-button type="info" @click="cancel">取消</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <!--图片预览-->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="list" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="goBack" />
  </div>
</template>

<script>
import { ActivityPhoto } from '@/model/ActivityPhoto';
import UploadImage from '@/components/UploadImage';
import { mapState } from 'vuex';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import Dialog from '@/components/Dialog';

export default {
  components: { UploadImage, Dialog, ElImageViewer },
  data() {
    return {
      form: new ActivityPhoto(),
      statusList: [],
      fileList: [],
      formDialogShow: false,
      information: {},
      showViewer: false,
      list: [],
      type: undefined, // 用户获取详情
    };
  },
  watch: {
    form: {
      handler(val) {
        if (val.photos && Array.isArray(val.photos)) {
          this.list = val.photos.map((item) => item.url);
          this.initList = val.photos.map((item) => item.url);
        }
      },
      deep: true,
    },
  },
  mounted() {
    const { query } = this.$route;
    this.id = Number(query.id);
    this.objectType = 3;
    this.form = new ActivityPhoto(query);
    this.getListType();
    this.fetchData();
  },
  computed: {
    ...mapState('activity', ['citySelectVO']),
  },
  methods: {
    getListType() {
      this.$Api.uara.getUaraTypeList().then(res => {
        this.statusList = res;
      });
    },
    fetchData() {
      this.$Api.activity.getHighlightMomentDetails(this.objectType, this.id)
        .then((res) => {
          if (res) {
            this.form.photos = res.photos;
          }
        });
    },
    cancel() {
      const _this = this;
      this.formDialogShow = true;
      this.information = {
        operation: 'back',
        icon: 'warn',
        subTitle: `是否放弃上传，返回上级页面？`,
      };
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 高光时刻未设置封面 使第一张图成为封面
          if (!this.form.photos.some(item => item.isCoverPhoto === 0) && this.form.photos.length) {
            this.form.photos[0].isCoverPhoto = 0;
          }
          this.form.photos = this.form.photos.map((item) => {
            if (item.id) delete item.id;
            return item;
          });
          this.$Api.activity.updateHighlightMoment({ ...this.form, objectId: this.form.id, objectType: this.objectType }).then(res => {
            this.$message.success('保存成功');
            this.goBack();
          });
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.$router.back(-1);
    },
    onPreview(index) {
      this.showViewer = true;
      const tempSrcList = [...this.initList];
      const temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempSrcList.shift());
      }
      this.list = tempSrcList.concat(temp);
    },
    setCover(_index) {
      this.form.photos.map((item, index) => {
        item.isCoverPhoto = index === _index ? 0 : 1;
      });
    },
    remove(index) {
      const images = [...this.form.photos];
      images.splice(index, 1);
      this.form.photos = images;
      this.$refs.form.validateField('photos');
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    handlePushUploader(file) {
      this.uploader(file);
    },
    uploader(file) {
      this.fileList.push(file.raw);
    },
    submitUpload() {
      const types = ['png', 'jpg', 'jpeg'];
      const savePath = 'uara-activity/images/';
      this.$Api.uploadFile.uploadImageList(this.fileList, savePath, types, true).then(data => {
        const { uploadSuccessList, uploadFailList } = data;
        this.$refs.uploader.clearFiles();// 清空文件列表
        const tempArr = [];
        // 上传成功
        uploadSuccessList.map((item) => {
          const photo = {
            isCoverPhoto: 1,
            type: 0,
            objectId: this.id,
            objectType: this.objectType,
            url: item.describe,
          };
          tempArr.push(photo);
        });
        this.form.photos = [...this.form.photos, ...tempArr];
        this.fileList = [];

        // 上传失败
        if (uploadFailList.length) {
          let errMsg = '';
          uploadFailList.map((item) => {
            errMsg = errMsg + (`${item.name}上传失败，失败原因：${item.describe}<br />`);
          });
          this.$message.error({
            dangerouslyUseHTMLString: true,
            message: errMsg,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.btns {
  button {
    width: 120px;
    height: 50px;
  }
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
}
.image-list {
  flex-wrap: wrap;
  .image-item {
    width: 150px;
    height: 150px;
    text-align: center;
    margin-right: 10px;
    margin-bottom: 10px;
    .img-wrap {
      border: 1px dashed #e5e5e5;
      width: 100%;
      height: 100%;
      position: relative;
      &:hover {
        .mask {
          display: block;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
      .cover {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
      }
      .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        display: none;
        .close-icon {
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          cursor: pointer;
        }
        .operation {
          width: 100%;
          height: auto;
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
